module.exports = __webpack_public_path__ + "static/media/sun-weather_200_transparent.fcc0dfcb.gif";